<template>
  <div class="body-wrapper">
    <a href="https://wa.me/6598433982" target="_blank" class="btn-wa">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48"><path fill="none" d="M0 0h24v24H0z"/><path d="M2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308a.961.961 0 0 0-.371.1 1.293 1.293 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.729 2.729 0 0 0 6.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.971 2.742.214.213.423.427.648.626a9.448 9.448 0 0 0 3.84 2.046l.569.087c.185.01.37-.004.556-.013a1.99 1.99 0 0 0 .833-.231c.166-.088.244-.132.383-.22 0 0 .043-.028.125-.09.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.401-.621a.498.498 0 0 0-.177-.041.482.482 0 0 0-.378.127v-.002c-.005 0-.072.057-.795.933a.35.35 0 0 1-.368.13 1.416 1.416 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.109l-.005-.002a6.01 6.01 0 0 1-1.57-1c-.126-.11-.243-.23-.363-.346a6.296 6.296 0 0 1-1.02-1.268l-.059-.095a.923.923 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41a4.38 4.38 0 0 0 .263-.373c.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 0 0-.403.004z" fill="rgba(35,205,100,1)"/></svg>
    </a>
    <div class="w-full header-banner">
      <div class="w-full header-bg">
        <div class="w-full header-top">
          <div class="container px-4 pt-6">
            <div class="w-full flex pt-4 pb-4">
              <div class="w-3/6 md:w-4/12 lg:w-4/12">
                <router-link class="m-auto" to="/"><img class="m-auto md:m-0" src="/images/logo.png"></router-link>
              </div>              
              <div class="w-5/6 md:w-6/10 lg:w-7/12 text-left flex items-center justify-end">                
                <div class="pr-0 block md:block">
                  <img class="w-5/6 hidden lg:block" src="/images/tel-icon.png">
                  <img class="w-5/6 block lg:hidden" src="/images/tel-icon.png">
                </div>
                <div class="block">
                  <div class="font-bold lg:text-2xl text-gray-800">Call us at<br><a href="tel:+6598433982">(+65) 9843 3982</a></div>                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container px-4 pt-0 lg:pt-2">
          <div class="w-full lg:flex section">
            <div class="w-full lg:w-7/12 text-center md:text-center lg:text-left">
              <div class="text-5xl md:text-5xl lg:text-6xl xl:text-6xl lg:text-blue font-bold title-text">
                <!-- Specialise In  -->SG Cheapest<br class="hidden sm:inline"> Painting Services
              </div>
              <div class="text-2xl lg:text-4xl text-gray-800 lg:text-gray-800 font-bold leading-10 mb-8 md:mb-16 lg:mb-8">
                <div class="pb-0 lg:pb-12 text-4xl lg:text-5xl xl:text-6xl">
                  <!-- ALL Residential<br class="block"><div class="pt-2 lg:pt-4 xl:pt-8">Painting Works</div> -->
                   <br class="hidden sm:inline">with Top Quality<br class="block"><div class="pt-2 lg:pt-4 xl:pt-8">Paint & Inhouse<br class="hidden sm:inline"><br class="hidden sm:inline">Qualified Painting<br class="hidden sm:inline"><br class="hidden sm:inline">Crew!</div>
                </div>
                <div class="text-xl text-bright-red font-semibold text-shadow-xl lg:text-xl mt-20 lg:mt-24 leading-tight">
                  <!--Save you TIME, SWEAT and<br class="block">MONEY by choosing us<br class="block">to paint your house today.-->
                  <!-- Limited Time Offer!<br class="block">30% discount off all painting works<br class="block">Applicable for all NEW CUSTOMERS<br class="block">Get in touch with us today! -->
                  Time & Money are the essence!<br class="hidden lg:inline"> Get A Fresh Coat of Paint in hours<br class="hidden lg:inline"> with our inhouse crew Today!
                  <!-- <br><br>
                  STOP paying obnoxious prices to<br class="hidden lg:inline"> middleman & Low Skill freelancers<br class="hidden lg:inline"> and ONLY use TOP quality paint with<br class="hidden lg:inline"> trained and direct painters today! -->
                </div>
              </div>              
              <div class="w-full hidden pt-2 md:pt-2 lg:block">
                <img src="/images/header-icon.png" class="md:pt-2">
              </div>
              <div class="w-full block lg:hidden">
                <img class="m-auto" src="/images/header-img-m.png">
              </div>
            </div>
            <div class="w-1/12 hidden lg:block"></div>
            <div id="contact-area" class="w-full md:w-9/12 lg:w-4/12 m-0 md:m-auto">
              <div class="w-full ">
                  <!-- <div class="w-full bg-white p-8"> -->
                  <!-- <div class="text-3xl text-center text-yellow-500 font-bold pt-2 lg:text-4xl lg:pt-4 xl:pt-2">Call us at<br class="block"><a href="tel:+6598433982">(+65) 9843 3982</a></div><div class="text-3xl text-center text-green-500 font-bold pt-2 lg:text-4xl lg:pt-4 xl:pt-2">(or)<br class="block"><a href="https://wa.me/6598433982" target="_blank">Whatsapp us</a></div> -->
                  <!-- <div class="w-full text-center text-3xl text-gray-800 font-bold leading-none mb-6 mt-5">
                    <span class="text-2xl lg:text-3xl">Request a</span><br/><span class="text-4xl lg:text-5xl font-extrabold">Free Quote</span>
                  </div> -->
                  <!-- feedback.activamedia.com.sg script begins here -->
                  <!-- <iframe allowTransparency="true" style="min-height:620px; height:inherit; overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="https://feedback.activamedia.com.sg/my-contact-form-5709397.html">
                    <p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p>
                  </iframe> -->
                  <!-- feedback.activamedia.com.sg script ends here -->
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full text-center md:flex mt-12">
      <div class="container px-4 pt-6 mx-auto flex flex-row items-center justify-between">
        <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
        <div class="w-1/1 text-4xl md:text-5xl text-blue-400 font-bold leading-none title-text">
          Promotion
        </div>
        <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
      </div>
    </div>
    <div class="w-full pt-10 md:pt-0 lg:pt-12">
      <div class="container px-4 pt-6 mx-auto flex flex-col lg:flex-row">       
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-0 lg:pr-8" id="hdb">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              HDB FLATS
            </div>
            <div class="block text-lg text-center text-yellow-400 font-bold bg-gray-900 pt-2 pb-2 h-26">
              <span class="text-xl">STARTING FROM</span><br/><span class="text-4xl">$500</span><br/><span class="text-xl">NETT</span>
            </div>
            <div class="block bg-gray-400 pt-3 h-auto pb-3">
              <ul>
                <li class="pb-2">2 room flat $600</li>
                <li class="pb-2">3 room flat $800</li>
                <li class="pb-2">4 room flat $1000</li>
                <li class="pb-2">5 room flat $1100</li>
                <li class="pb-2">Executive $1200</li>
                <li class="pb-2">Maisonette $1600</li>
                <!-- <li class="pb-2">Many types of paints to choose from</li>
                <li class="pb-2">Labour and all services included</li>
                <li class="pb-2">Exterior paint quote based on site survey</li>
                <li class="pb-2">COMPLETION WITHIN 7 DAYS</li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-0 lg:pr-4" id="condominium">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              CONDOMINIUM
            </div>
            <div class="block text-lg text-center text-yellow-400 font-bold bg-gray-900 pt-2 pb-2 h-26">
              <span class="text-xl">STARTING FROM</span><br/><span class="text-4xl">$600</span><br/><span class="text-xl">NETT</span>
            </div>
            <div class="block bg-gray-400 pt-3 h-auto pb-3">
              <ul>
                <li class="pt-2 pb-2">600sqft $600</li>
                <li class="pb-2">900sqft $800</li>
                <li class="pb-2">1100sqft $1000</li>
                <li class="pb-2">1300sqft $1100</li>
                <li class="pb-2">1400sqft $1200</li>
                <li class="pb-2">1401sqft $1300</li>
                <!-- <li class="pt-2 pb-2">White based paint</li>
                <li class="pb-2">Other types of paint or colour available</li>
                <li class="pb-2">Paint warranty up to 5 years</li>
                <li class="pb-2">License application inclusive</li>
                <li class="pb-2">COMPLETION WITHIN 1-2 DAYS</li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-4 lg:pr-4" id="landed-interior">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              LANDED INTERIOR
            </div>
            <div class="block text-lg text-center text-yellow-400 font-bold bg-gray-900 pt-2 pb-2 h-26">
              <span class="text-xl">STARTING FROM</span><br/><span class="text-4xl">$2500</span><br/><span class="text-xl">NETT</span>
            </div>
            <div class="block bg-gray-400 pt-3 h-auto pb-3">
              <ul>
                <li class="pt-2 pb-2">Inter Terrace $2500</li>
                <li class="pb-2">Corner Terrace $3000</li>
                <li class="pb-2">Semi Detached $3500</li>
                <li class="pb-2">Detached $4000</li>
                <li class="pb-2">Shophouse Free Onsite Quote</li>
                <li class="pb-2">Good Class Bungalow FOQ</li>
                <!-- <li class="pt-2 pb-2">Price starting from 3-room flats</li>
                <li class="pb-2">Paint warranty up to 5 years</li>
                <li class="pb-2">Premium paint selection available</li>
                <li class="pb-2">Fast and experienced team</li>
                <li class="pb-2">COMPLETION WITHIN 1 DAY</li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="w-full mb-10 lg:mb-0">
          <div class="pl-0 pr-0 lg:pl-4 lg:pr-0" id="landed-exterior">
            <div class="block text-2xl text-center text-white font-bold bg-blue-400 pt-2 pb-1 h-auto title-bg-color">
              LANDED EXTERIOR
            </div>
            <div class="block text-lg text-center text-yellow-400 font-bold bg-gray-900 pt-2 pb-2 h-26">
              <span class="text-xl">STARTING FROM</span><br/><span class="text-4xl">$2500</span><br/><span class="text-xl">NETT</span>
            </div>
            <div class="block bg-gray-400 pt-3 h-auto pb-3">
              <ul>
                <li class="pt-2 pb-2">Inter Terrace $2500</li>
                <li class="pb-2">Corner Terrace $3000</li>
                <li class="pb-2">Semi Detached $3500</li>
                <li class="pb-2">Detached $4500</li>
                <li class="pb-2">Shophouse Free Onsite Quote</li>
                <li class="pb-2">Good Class Bungalow FOQ</li>                
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>    
    <div class="w-full mt-8 lg:mt-12">
      <div class="w-full">        
        <div class="w-full lg:flex lg:pt-6 mb-12">
          <div class="w-full bg-cover lg:w-6/12">
            <img src="/images/promotion-bg.jpg" class="h-full" width="100%" height="100%">
          </div>
          <div class="w-full lg:w-6/12 lg:pl-12 title-bg-color">
            <div class="px-4 text-4xl md:text-5xl text-white font-bold leading-none pt-16 mb-3">
              Our Expertise
            </div>
            <div class="px-4 text-lg text-white leading-snug pt-6 mb-10">
              We promise to serve our customers with the most professional and efficient way.
            </div>
            <div class="px-4 text-lg text-white leading-8 mb-5 pr-4">
              With more than a decade of experience in painting services, our team is able to deliver fast and efficient painting jobs to meet our customer’s expectations.
            </div> 
            <div class="mb-4 p-4 text-white">
              <table cellpadding="0" cellspacing="0" class="text-base md:text-lg text-white leading-snug w-full">
              <tr>
                <td valign="top" width="25px"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">HDB</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Condominium</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Landed Property</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">School</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Hospital</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Warehouse</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Office</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Restaurant</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Shophouse</td>
              </tr>
              <tr>
                <td valign="top"><img class="xl:ml-auto" src="/images/icon-check.png"></td>
                <td class="pb-5 pl-3">Factory</td>
              </tr>
            </table>            
            </div>
          </div>
        </div>        
      </div>
    </div>
    <!-- ///////////////////////////////////////// OUR 4 icons START ///////////////////////////////////////// -->
    <div class="w-full text-center md:flex mt-12">
      <div class="container px-4 pt-6 mx-auto flex flex-row items-center justify-between">
        <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
        <div class="w-1/2 text-4xl md:text-5xl text-blue-400 font-bold leading-none title-text">
          Your Right Choice
        </div>
        <div class="w-1/5 lg:w-1/3 md:block title-line"></div>
      </div>
    </div>
    <div class="w-full section">
      <div class="container px-4 pt-4 pb-2 lg:pt-0 flex flex-wrap mx-auto items-center justify-between">
        <div class="w-1/2 lg:w-1/4 pr-2 border-r-0 sm:border-r-0 lg:border-r-2 mt-6 border-black">
          <img src="images/icon-01.png" class="w-1/2 h-1/1 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">Satisfaction<br/>Guaranteed</div>
        </div>
        <div class="w-1/2 lg:w-1/4 pr-2 border-r-0 sm:border-r-0 lg:border-r-2 mt-6 border-black">
          <img src="images/icon-02.png" class="w-1/2 h-1/1 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">5 Stars<br/>Reviews</div>
        </div>
        <div class="w-1/2 lg:w-1/4 pr-2 pb-8 lg:pb-0 border-r-0 sm:border-r-0 lg:border-r-2 mt-6 border-black">
          <img src="images/icon-03.png" class="w-1/2 h-1/1 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">On-site<br/>Quotation</div>
        </div>
        <div class="w-1/2 lg:w-1/4 pl-2 pb-8 lg:pb-0 mx-auto">
          <img src="images/icon-04.png" class="w-1/2 h-1/1 mt-6 mx-auto" />
          <div class="font-bold text-center mt-4 text-xl lg:text-2xl">Most<br/>Competitive Rates</div>
        </div>
      </div>
    </div>
    <!-- ///////////////////////////////////////// OUR 4 icons END ///////////////////////////////////////// -->
    <!-- ///////////////////////////////////////// Ph section START ///////////////////////////////////////// -->
    <div class="max-w-none bg-cover bg-middle bg-center bg-no-repeat bg-img-01 py-12">     
      <div class="container px-4 mx-auto py-12 lg:content-center flex flex-wrap">
        <div class="w-full rounded-full py-2 lg:py-4 px-6 border-4 border-blue-200 bg-blue-400">        
            <div class="text-1xl text-center lg:text-3xl text-white font-bold">
              CALL US AT <a href="tel:+6598433982"><span class="text-2xl lg:text-4xl text-yellow-400">9843 3982</span></a> TO GET AN INSTANT QUOTE!    
            </div>
        </div>
      </div>
    </div>
    <!-- ///////////////////////////////////////// Ph section END ///////////////////////////////////////// -->
    <div class="w-full section">
      <div class="container px-4 pt-0 lg:pt-0 mx-auto flex flex-col lg:flex-row items-center justify-between">
          <div class="w-1/1 lg:w-1/2 mx-auto">
            <div class="title-text">
              <div class="font-bold lg:font-extrabold text-2xl lg:text-3xl text-center lg:text-left leading-4">Enquire on</div>
              <div class="font-bold text-3xl lg:text-5xl text-center lg:text-left leading-12">Our Painting</div> 
              <div class="font-bold text-3xl lg:text-5xl text-center lg:text-left leading-10">Services Today</div>
              <!-- <div class="font-bold text-5xl lg:text-5xl text-center lg:text-left leading-12"></div>  -->
              <div class="py-6 pr-none lg:pr-8 text-justify lg:text-left text-gray-900 mt-2 lg:mt-12">
                You can also whatsapp us a video of your house so that we can give you a quotation as soon as possible. If not you can also request for a on-site inspection. Contact us today and let us know your ideal date of painting!
              </div>
            </div>
          </div>           
          <!--<div class="w-full sm:w-full lg:w-1/3 mx-auto px-10 py-10 bg-gray-100">
            <div class="text-center text-gray-800 font-bold leading-none">
              <span class="text-2xl lg:text-3xl">Request a</span><br/><span class="text-4xl lg:text-5xl font-extrabold">Free Quote</span>
            </div>-->            
            <!-- feedback.activamedia.com.sg script begins here --><!--<iframe allowTransparency="true" style="min-height:620px;height:inherit;overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="//feedback.activamedia.com.sg/my-contact-form-5709397.html"><p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p></iframe>--><!-- feedback.activamedia.com.sg script ends here -->
          <!--</div>-->      
          <div class="w-full sm:w-full md:w-full lg:w-1/3 pl-0 lg:pl-8 mx-auto">
            <img src="images/man.png" width="100%" />
          </div>
      </div>
    </div>    
    <div class="title-bg-color section" id="testimonials">
      <div class="container">
        <div class="w-full text-center text-3xl md:text-5xl text-white font-bold leading-none mb-12">
          What Customer Say About Us
        </div>
        <div class="w-full flex flex-wrap">
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <div class="mx-auto px-3 lg:px-8 py-8 bg-white">
              <div class="text-base md:text-lg text-gray-800 leading-snug pb-8 lg:pb-0 testimony-height">
                Very satisfied with their quality of paint and the delivery time! They managed to complete my HDB flat in 1 day and with no shortcuts too! The guys were very professional and had all the tools and equipment ready to paint. Double like their job!
              </div>
              <div class="w-full text-lg font-bold text-gray-800 leading-snug">
                Phua
                <img src="/images/icon-star.jpg">
              </div>
            </div>
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8  pr-4 pl-4">
            <div class="mx-auto px-3 lg:px-8 py-8 bg-white">
              <div class="text-base md:text-lg text-gray-800 leading-snug pb-8 lg:pb-0 testimony-height">
                Found these guys online and they really did their job well! Very on point and no mistakes, especially those small areas which requires more attention ones, they managed to pull off very well. Service is top-notch. Will recommend others too!
              </div>
              <div class="w-full text-lg font-bold text-gray-800 leading-snug">
                Bill Pang
                <img src="/images/icon-star.jpg">
              </div>
            </div>
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <div class="mx-auto px-3 lg:px-8 py-8 bg-white">
              <div class="text-base md:text-lg text-gray-800 leading-snug pb-8 lg:pb-0 testimony-height">
                I always thought that landed house will take at least a month to complete but Paintland managed to complete the whole painting job within a week! They had all the precautionary measures in place, make us very safe and trust them.
              </div>
              <div class="w-full text-lg font-bold text-gray-800 leading-snug">
                Miss Toh PY
                <img src="/images/icon-star.jpg">
              </div>
            </div>
          </div>
          <div class="w-1/2 md:w-1/2 lg:w-1/4 mb-8 pr-4 pl-4">
            <div class="mx-auto px-3 lg:px-8 py-8 bg-white">
              <div class="text-base md:text-lg text-gray-800 leading-snug pb-8 lg:pb-0 testimony-height">
                Very Good, Efficient, Speedy, Careful and painters. Whole process took only a few days even though I had many different colours to paint. Very friendly and accommodating providers, thumbs up for their service!
              </div>
              <div class="w-full text-lg font-bold text-gray-800 leading-snug">
                Lee Kai Tong
                <img src="/images/icon-star.jpg">
              </div>
            </div>
          </div>
        </div>
        <!-- ///////////////////////////////////////// Phone section START ///////////////////////////////////////// -->
        <div class="max-w-none bg-cover bg-middle bg-center bg-no-repeat">     
          <div class="container px-4 pt-6 mx-auto py-6 lg:content-center flex flex-wrap">
            <div class="w-full rounded-full py-2 lg:py-4 px-6 border-4 border-blue-200 bg-blue-400">        
                <div class="text-1xl text-center lg:text-3xl text-white font-bold">
                  CALL US AT <a href="tel:+6598433982"><span class="text-2xl lg:text-4xl text-yellow-400">9843 3982</span></a> TO GET AN INSTANT QUOTE!    
                </div>
            </div>
          </div>
        </div>
        <!-- ///////////////////////////////////////// Phone section END ///////////////////////////////////////// -->
      </div>
    </div>
    <div class="w-full about-bg lg:flex">
      <div class="w-full lg:w-12/12">
        <img class="xl:ml-auto w-full h-full" src="/images/about-img.jpg">
      </div>
      <div class="w-full lg:w-12/12 pt-12 pb-12 lg:pt-0 lg:pb-0 flex items-center justify-center">
        <div class="w-full xl:w-9/12 pl-3 pr-3 lg:pl-6 lg:pr-6 lg:m-auto xl:pl-3 py-6">
          <div class="w-full text-3xl md:text-5xl text-white font-bold leading-10 lg:leading-12 mb-12">
            <div class="text-2xl md:text-3xl">About Us</div>
            Paintland Construction
          </div>
          <div class="text-lg text-white leading-snug">            
            <p>
              Paintland House Painting Services provides professional House Painting Services in Singapore.
              <br/><br/>
              We pride ourself as a professional landed house painting specialist. Using only the best quality material and using scaffolding and gondolas to access heights following the right safety standards. With years of experience and track records for taking care of landed properties and other residential places.
              <br/><br/>
              We have many other range of premium paints suitable for every needs of home owners. Contact us today to find our the best rates for your painting jobs!
            </p>            
          </div>
        </div>
      </div>      
    </div>
    <div class="w-full section-t">
      <div class="container px-4">
        <div class="w-full lg:flex lg:items-center lg:justify-center pb-12">          
          <div class="w-full lg:w-3/6 text-center">
            <img class="m-auto pb-6" src="/images/logo-painting.png">
            <div class="text-2xl md:text-3xl font-bold text-gray-800 leading-snug pb-10">
              Paintland Construction
            </div>
            <div class="text-base md:text-lg text-gray-800 leading-snug">
              22 Sin Ming Lane #06-76<br/>Midview City Singapore 573969<br/>
              Tel: <a href="tel:+6598433982">(+65) 9843 3982</a>  |  E-mail: <a href="mailto:sales@painting.com.sg">sales@painting.com.sg</a>
            </div>
          </div>
        </div>
        <div class="text-2xl text-center md:text-3xl font-bold text-gray-800 leading-snug pb-10">
              Request For An Instant Quote Now
        </div>
        <div class="w-full flex flex-col lg:flex-row justify-center">
          <div class="w-full mb-8 flex lg:pr-8  lg:w-1/2 justify-center lg:justify-end">
            <a href="tel:+6598433982"><div class="blue-btn flex"><img class="m-auto pl-12" src="/images/tel-icon-02.png"> <div class="w-full text-2xl pl-10">Call Us<br/>9843 3982</div></div></a>
          </div>
          <div class="w-full flex lg:pl-8 lg:w-1/2 justify-center lg:justify-start">
            <a href="https://wa.me/6598433982" target="_blank"><div class="green-btn flex"><img class="m-auto pl-8" src="/images/tel-icon-03.png"> <div class="text-2xl pl-8 pr-8">WhatsApp Us<br/>9843 3982</div></div></a>
          </div>          
        </div>        
        <!-- <div class="w-full flex justify-center">
          <a href="#contact-area" v-smooth-scroll="{ duration: 2500}"><div class="red-btn">Request a<br/><span class="text-2xl">FREE QUOTE</span></div></a>
        </div> -->
      </div>
    </div>
    <div class="w-full bg-white pt-5 pb-8 border-t-2 border-gray-300">
      <div class="container px-4 pt-6 text-center">
        <div class="w-full text-gray-800 text-sm">Website maintained by Activa Media. All right reserved.</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-wa {  
  background-color: #f2f2f2;
  border-radius: 100%;
  position: fixed;
  padding: 8px;
  bottom: 15px;
  right: 15px;
  z-index: 100;
}
</style>

<script>
import carousel from 'vue-owl-carousel'
import vueSmoothScroll from 'vue-smooth-scroll'
export default {
  components: {
    vueSmoothScroll,
    carousel
  }
}
</script>